<template>
  <div class="indexList MediareportList">
    <div class="haveContent" id="haveContent" v-if="listAllData">
      <mescroll-vue ref="mescroll" :up="mescrollUp" @init="mescrollInit" style="height:100%">
        <div :id="'mediaEmpot'+myIndex"></div>
        <!-- 轮播图 -->
        <van-swipe
          v-if="swiperImages && swiperImages.length"
          class="my-swipe"
          :autoplay="3000"
          indicator-color="white"
        >
          <van-swipe-item
            v-for="(item, index) in swiperImages"
            @click="goToArticle(item)"
            :key="index"
          >
            <div class="thumbImg">
              <div class="thumbImg">
                  <div class="linearback"></div>
                  <p class="thumbImgTitle">{{item.mainContributionTitle}}</p>
                  <img
                    v-if="JSON.parse(item.contributionCover)[0]"
                    :src="JSON.parse(item.contributionCover)[0]"
                    alt
                  />
                  <img v-else src="../../assets/images/default.png" alt />
                </div>
            </div>
          </van-swipe-item>
        </van-swipe>
        <!-- <div class="swiperBox" v-if="listAllData.HD&&listAllData.HD.length">
          <div class="swiper-container" :class="'sonList' + myIndex">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,index) in listAllData.HD" :key="index">
                <div class="thumbImg">
                  <img
                    v-if="JSON.parse(item.contributionCover)[0]"
                    :src="JSON.parse(item.contributionCover)[0]"
                    alt
                  />
                  <img v-else src="../../assets/images/default.png" alt />
                  <p class="thumbImgTitle">{{item.mainContributionTitle}}</p>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div> -->
        <div class="newsBox">
          <div class="borderBox"></div>
            <newslist :listcontent="newsDataList"></newslist>
        </div>
      </mescroll-vue>
    </div>
    <loading :iscomplete="listAllData?false:true"></loading>
  </div>
</template>

<script>
// import Swiper from 'swiper';
// import '../../assets/swiper.min.css';
import newslist from './NewsList.vue' //新闻列表
import loading from './loading.vue' //加载动画
//import roofPlacement from './roofPlacement.vue'
import MescrollVue from 'mescroll.js/mescroll.vue' //上拉加载，下拉刷新
import Homeapi from "@/api/home";
export default {
  props: {
    currentdisplay: {
      type: Number,
      default: () => 1, //必须是一个函数
      required: false,  //不是必填项
    },
    myIndex: {
      type: Number,
      default: () => 1, //必须是一个函数
      required: false,  //不是必填项
    },
    datalink: {
      type: Object,
      default: () => { }, //必须是一个函数
      required: true,  //不是必填项
    }
  },
  data() {
    return {
      listAllData: [], //页面数据
      newsDataList: [], //新闻列表
      swiperContent: null, //轮播图
      mescroll: null, // mescroll实例对象
      mescrollUp: {
        callback: this.upCallback, // 上拉回调,此处可简写; 相当于 callback: function (page, mescroll) { getListData(page); }
        page: {
          num: 0, // 当前页码,默认0,回调之前会加1,即callback(page)会从1开始
          rows: 10 // 每页数据的数量
        },
        htmlLoading: '<p class="upwarp-progress mescroll-rotate"></p><p class="upwarp-tip">加载中..</p>',
        htmlNodata: '<p class="upwarp-nodata">-- 到底啦 --</p>',
        noMoreSize: 5, // 如果列表已无数据,可设置列表的总数量要大于等于5条才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
        // toTop: {
        //   src: require('../../assets/mescroll/mescroll-totop.png') // 回到顶部按钮的图片路径,支持网络图
        // },
        auto: true,
        lazyLoad: {
          use: true // 是否开启懒加载,默认false
        }
      },
      swiperImages: null,
    }
  },
  created(){
    var empty = {
      //列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
      warpId: "mediaEmpot" + this.myIndex, //父布局的id (1.3.5版本支持传入dom元素)
      icon: require('../../assets/mescroll/mescroll-empty.png'), // 图标,支持网络图
      tip: "暂无数据" //提示
    }
    this.mescrollUp.empty = empty;
  },
  components: {
    newslist,  //新闻列表
    loading,
    MescrollVue,
    // roofPlacement //置顶
  },
  methods: {
    // 轮播图
    // InitializationSwiper() {
    //   if (this.swiperContent) {
    //     this.swiperContent.destroy();
    //   }
    //   var that = this;
    //   this.swiperContent = new Swiper('.sonList'+this.myIndex, {
    //     direction: 'horizontal', // 垂直切换选项
    //     loop: true, // 循环模式选项
    //     touchMoveStopPropagation: true, //阻止事件冒泡

    //     autoplay: {
    //       delay: 3000,
    //       stopOnLastSlide: false,
    //       disableOnInteraction: false,
    //     },

    //     // 如果需要分页器
    //     pagination: {
    //       el: '.swiper-pagination',
    //     },

    //     on: {
    //       click: function () {
    //         var x;
    //         if (this.clickedIndex == that.listAllData.HD.length + 1) {
    //           x = that.listAllData.HD[0];
    //         } else if (this.clickedIndex == 0) {
    //           x = that.listAllData.HD[that.listAllData.HD.length - 1];
    //         } else {
    //           x = that.listAllData.HD[this.clickedIndex - 1];
    //         }

    //         console.log(x);
    //         var link;
    //         if (x.contributionOtherUrl) {
    //           link = x.contributionOtherUrl; //链接
    //         } else if (x.contributionType=='IMAGE_TYPE') {
    //           link = window.location.href.split("#/")[0] + "#/tabloid?id=" + x.id; //链接
    //           that.linkPhone({ url: link, title: x.mainContributionTitle ,isHideTitle:true});
    //           return false;
    //         } else {
    //           link = window.location.href.split("#/")[0] + "#/detailsTwo?id=" + x.id; //链接
    //         }
    //         // // window.location.href=link;
    //         that.linkPhone({ url: link, title: x.mainContributionTitle });
    //       }
    //     }
    //   })
    // },
    // 跳外链
    jumpOutside(item) {
      this.linkPhone({
        url: item.outlinker,
        title: item.title
      });
    },
    mescrollInit(mescroll) {
      this.mescroll = mescroll
    },
    // 上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
    upCallback(page, mescroll) {
      let params = {
        page: page.num,
        rows: page.rows,
        appName: this.appName,
        columnId: this.datalink.id
      }
      Homeapi.getColumnContribution(params)
        .then(resp => {
          if (resp.success) {
            if (page.num === 1) {
              this.listAllData = resp.data;
              this.newsDataList = [];
              if (this.listAllData.HD) {
                this.$nextTick(() => {
                  this.swiperImages = resp.data.HD;
                })
              }
            }
            if (resp.data.pageList) {
              this.newsDataList = this.newsDataList.concat(resp.data.pageList.items);
            }
          } else {
            // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
            mescroll.endErr()
          }
          this.$nextTick(() => {

            if (resp.data.pageList.items) {
              mescroll.endSuccess(resp.data.pageList.items.length);
            } else {
              console.log("ss")
              mescroll.endSuccess(0);
            }
          })
        }).catch(() => {
          // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          mescroll.endErr()
        })
    },
    // 进入分类
    classificationDetails(item) {
      // console.log(item);
      var link; //跳转链接
      if (item.outlinker) {
        link = item.outlinker;
      } else if (item.projectmarks == "diandan") { //群众点单
        link = window.location.href.split("#/")[0] + "#/massorder"; //链接
      } else if (item.projectmarks == "zhaomu") { //活动招募
        link = window.location.href.split("#/")[0] + "#/voluntaryRecruitment"; //链接
      } else if (item.projectmarks == "xuexi") { //学习园地
        link = window.location.href.split("#/")[0] + "#/study?datalink=" + item.linkurl; //链接
      } else if (item.projectmarks == "shop") { //积分商城
        link = window.location.href.split("#/")[0] + "#/shoppingMall/commodity"; //链接
        this.linkPhone({ //不需要导航头
          url: link,
          title: item.title,
          isHideTitle: true
        });
        return false;
      } else {  //阵地建设
        link = window.location.href.split("#/")[0] + "#/bulid?datalink=" + item.linkurl; //链接
      }
      window.location.href = link;
      // 在APP上另打开一个页面
      // this.linkPhone({
      //     url: link,
      //     title: item.title
      // });
    },
    // 轮播图跳文章详情
    goToArticle(val) {
      var link;
      if (val.contributionOtherUrl) {
        link = val.contributionOtherUrl; //链接
      } else if (val.contributionType == "IMAGE_TYPE") {
        link =
          window.location.href.split("#/")[0] + "#/tabloid?id=" + val.id; //链接
        this.linkPhone({
          url: link,
          title: val.mainContributionTitle,
          isHideTitle: true,
        });
        return false;
      } else {
        link =
          window.location.href.split("#/")[0] + "#/detailsTwo?id=" + val.id; //链接
      }
      // // window.location.href=link;
      this.linkPhone({ url: link, title: val.mainContributionTitle });
    }
  }
}
</script>
<style>
.MediareportList .mescroll-empty{
  margin-top: 100px;
}
</style>
<style scoped>
.indexList {
  width: 100%;
  height: 100%;
  position: relative;
}
.swiper-container {
  --swiper-pagination-color: #d81920;
}
.indexList .swiper-container {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
}
.swiperBox {
  width: 100%;
  padding-bottom: 60%;
  position: relative;
}
.outLinkerContent {
  width: 100%;
  padding-bottom: 20%;
  position: relative;
  /* margin-top: 15px; */
}
.outLinkerContentBox {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.outLinkerPer {
  width: 20%;
  height: 80%;
  /* text-align: center; */
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.outLinkerPerPer {
  width: 100%;
  height: 56%;
}
.outLinkerPerPer img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.outLinkerPerTitle {
  width: 100%;
  /* line-height: 25px; */
  font-size: 0.28rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}
.class_body {
  display: flex;
  flex-wrap: wrap;
  margin: 0.21rem 0.28rem;
}
.class_list {
  border-radius: 5px;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 2vw;
  font-size: 0.13rem;
  width: 20%;
}
.class_content {
  /* width: 28vw; */
  /* text-align: center; */
  /* margin: 2vw 0; */
  font-size: 0.26rem;
  /* font-weight: bold; */
}
.class_btn {
  width: 16vw;
  background: #f61729;
  color: #fff;
  padding: 1px 5px;
  border-radius: 7px;
}
.class_list img {
  width: 9vw;
}
.data_all {
  height: 2.28rem;
  margin: 0 0.28rem 4vw;
  background: #ffffff;
  box-shadow: 1px 4px 3px 0px rgba(114, 44, 36, 0.05);
  border-radius: 10px;
}
.data_all img {
  width: 100%;
}
.sum_body {
  display: flex;
  justify-content: space-around;
  border-radius: 8px;
  margin-top: -3vw;

  padding: 0.2rem;
}
.sum_list {
  width: 20vw;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  margin: 2vw 0;
  border-right: 1px solid #bfbfbf;
  padding: 0 5px;
}
.sum_list:last-child {
  border-right: 0;
}
.sum_content {
  margin: 1vw 0;
  font-size: 0.31rem;
  font-weight: bold;
}
.sum_content_two {
  font-size: 0.22rem;
  color: #939393;
}
.wenming_img {
  display: flex;
  align-items: center;
  font-size: 0.31rem;
  font-weight: bold;
  padding: 2vw 3vw;
}
.wenming_img img {
  width: 6vw;
  margin-right: 5px;
}
.wenming_body {
  display: flex;
  margin: 0.21rem 0.28rem;
}
.wenming_wrapper {
  position: relative;
  width: 43vw;
}
.wenming_list {
  width: 43vw;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 2vw;
  border: 1px solid #dcdcdc;
}
.zhaomu_img {
  width: 17vw;
  position: absolute;
  top: 0;
}
.wenming_list img {
  width: 100%;
}
.wenming_content {
  /* width: 28vw; */
  /* text-align: center; */
  margin: 0.1rem 0;
  font-size: 0.3rem;
  padding-left: 0.2rem;
  font-weight: bold;
  width: 100%;
}
.wenming_content_two {
  margin: 0.1rem 0;
  font-size: 0.22rem;
  padding-left: 0.2rem;
  color: #939393;
  width: 100%;
}
.indexList .haveContent {
  width: 100%;
  height: 100%;
}
.indexList .thumbImg {
  width: 100%;
  height: 100%;
  position: relative;
}
.indexList .thumbImg .thumbImgTitle{
  width: 80%;
  position: absolute;
  left: 10%;
  bottom: 0.6rem;
  color: #fff;
  text-align: center;
  font-size: 18px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.indexList .thumbImg .linearback {
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  background: linear-gradient(to top,rgba(0,0,0,0.7),rgba(0,0,0,0));
}
.indexList .thumbImg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.indexList .swiper-pagination-bullet {
  width: 20px;
  height: 3px;
  border-radius: 0px;
  background: #ababab;
  opacity: 1;
}
.indexList .swiper-pagination-bullet-active {
  background: #fff;
}
.indexList .titleBunner {
  position: absolute;
  width: 100%;
  height: 20%;
  bottom: 0px;
  color: #333;
  font-size: 0.28rem;
  font-weight: 700;
  padding: 0px 10px;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background: #e6e6e6;
  padding-top: 5px;
}
.titleIndex {
  position: absolute;
  bottom: 0;
  right: 5px;
  font-size: 0.24rem;
  color: #ababab;
}
.titleIndex span {
  color: red;
  font-weight: 100;
}
.borderBox {
  /* border:  solid#e6e6e6; */
  /* width: 100%; */
  /* margin-top: -50px; */
}
/* .newsBox{
        margin-top: 18px;
    } */
.outSwiper {
  /* margin-top: 5px; */
  margin: 10px auto;
}
.my-swipe .van-swipe-item {
  color: #fff;
  height: 56vw;
  /* line-height: 150px; */
  text-align: center;
  /* background-color: #39a9ed; */
}
.imgBox {
  /* margin: 0 1px; */
  width: 20%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.imgBox img {
  width: 35px;
  height: 35px;
}
.outerTitle {
  font-size: 14px;
}
</style>